import {
	$smallImage
} from "./utils.js"
import {
	$getCurrentPage,
	$goTo
} from "./common.js"

export default {
	install(Vue) {
		Vue.prototype.$getTitleFromUrl = function (url) {
			// 从链接中获取标题
			if (url.indexOf(' ') > 0) {
				return url.substr(0, url.indexOf(' '));
			}
			return url;
		}
		Vue.prototype.$getLinkFromUrl = function (url) {
			// 从链接中获取URL
			if (url.indexOf(' ') > 0) {
				return url.substr(url.indexOf(' ')).trim();
			} else if (url.indexOf('://') || url[0] == '/' || url.startsWith('pages')) {
				return url;
			}
			return null;
		}

		Vue.prototype.$loadUserInfo = async function (nologin) {
			// 加载用户信息
			return await new Promise((resole, reject) => {
				this.$callapi("user/getUserInfo", {
					nologin
				}).then(res => {
					if (res && res.data) {
						this.$store.commit("SET_USER", res.data);
						resole(res.data);
					} else {
						resole(res);
					}
				}).catch(e => resole(e));
			});
		}
		Vue.prototype.$createFavorite = function ({
			model,
			objid,
			favorited,
			change
		}) {
			// 创建收藏管理上下文
			let cxt = {
				model: model,
				objid: objid,
				favorited: favorited,
				refresh: async () => {
					let r = await this.$callapi("user/queryCollects", {
						model: model,
						objids: objid
					})
					let v = r.data[objid] && true;
					this.$set(cxt, 'favorited', v)
				},
				toggle: async () => {
					let v = cxt.favorited || false
					if (v && !await this.$query(model.toLowerCase() == 'user' ? '确定取消关注吗?' : "确定取消收藏吗？"))
						return
					this.$doing()
					try {
						let r = await this.$callapi("user/doCollect", {
							model: model,
							objid: objid,
							action: v ? 'cancel' : 'collect'
						})
						if (r && r.data) {
							this.$set(cxt, 'favorited', !v)
							change && change(!v)
						}
					} catch (e) {
						console.error(e)
					}
					this.$done()
				},
			}
			if (favorited === undefined || favorited === null) {
				this.$nextTick(async () => {
					await cxt.refresh()
				})
			}
			return cxt;
		}

		Vue.prototype.$viewPoster = function (key, data, type) {
			// 显示海报
			let posterurl = this.$apiurl + `/utils/genposter.${type || 'jpeg'}?posterkey=${key}&` + this.$queryParam(data)
			console.log(posterurl);
			this.$viewImage(posterurl)
		}
	}
}
